var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-checkbox-group",class:{
    'is-invalid': _vm.isInvalid
  },attrs:{"role":"group","aria-label":"checkbox-group"}},[_c('div',{staticClass:"el-checkbox-group__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }